import React from "react";

const FullstackFace = ({ onOpenStore }) => {
  return (
    <div style={{ color: "white", fontFamily: "Arial, sans-serif" }}>
      <h2 style={{ color: "#00ffff", borderBottom: "2px solid #00ffff", paddingBottom: "10px" }}>
        💻 Full Stack Development
      </h2>
      <p style={{ marginTop: "15px", opacity: 0.9 }}>
        Especialista en arquitecturas robustas. Desde el diseño de la base de datos hasta interfaces futuristas para usuario final.
      </p>
      
      <div style={{ marginTop: "20px" }}>
        <h3 style={{ color: "#00ffff", fontSize: "16px" }}>Capacidades:</h3>
        <ul style={{ fontSize: "14px", opacity: 0.8 }}>
          <li>Backend escalable en Node.js / Python.</li>
          <li>Interfaces móviles multiplataforma.</li>
          <li>Despliegue automatizado en FrancoLab Cloud.</li>
        </ul>
      </div>

      <div style={{ 
        marginTop: "30px", padding: "20px", borderRadius: "15px", 
        background: "linear-gradient(45deg, rgba(0,255,255,0.1), transparent)",
        border: "1px solid #00ffff", textAlign: "center"
      }}>
        <h4 style={{ margin: "0 0 10px 0", color: "#00ffff" }}>📦 StoreFrancoLab</h4>
        <p style={{ fontSize: "13px", marginBottom: "15px" }}>Explora mis aplicaciones móviles de uso genérico listas para producción.</p>
        <button 
          onClick={onOpenStore}
          style={{ 
            background: "#00ffff", color: "#000", border: "none", 
            padding: "10px 25px", borderRadius: "10px", fontWeight: "bold", cursor: "pointer"
          }}>
          ABRIR CATÁLOGO 2050
        </button>
      </div>
    </div>
  );
};

export default FullstackFace;